import React from "react";
import { Button, TextBox } from "devextreme-react";
import styles from "../../../../styles/stylesgenerales";
import { envioEmailSMSActivacionCuentaNoSerie } from "../../../../services/ValidacionIdentidad";
import {
  ReenviarCodigoActivacionSMS,
  resolveNoSerieRestablecerConstraseñaAction,
  renderRedirectFlujoValidacionIdentidad,
} from "../actions";


const codeInputStyle = {
  fontSize: 20,
  marginLeft: 5,
};

class Step3 extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      fullcode: "",
      codeLength: 7,
      focus: 0,
    };

    this.textInput = React.createRef();
  }

  handleFocus = (e) => {
    if (
      e.previousValue.trim() === "" &&
      e.value.trim() !== "" &&
      this.state.focus < this.state.codeLength - 1
    ) {
      this.setState((prevState) => ({ focus: prevState.focus + 1 }));
    }
    this.textInput.focus();
  };

  handleChange = (e) => {
    if (e.value.trim().length === this.state.codeLength) {
      this.props.handleFullCode(e.value);
    } else {
      this.props.handleFullCode(false);
    }
  };

  render() {
    const { nextStep, codeError, disabled, reSend, typeSelected, emailMasked, phoneMasked, dispatch  } = this.props;

    return (
      <div className="acceso row" style={{ justifyContent: "center" }}>
        <div className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div style={{ textAlign: "justify" }}>
            <h2
              className={"titulo-validacion-cuenta"}
              style={{
                textAlign: "center",
                paddingTop: 20,
                marginBottom: "40px",
              }}
            >
              Restablecimiento de contraseña
            </h2>
            <h4
              className={"subtitulo-validacion-cuenta"}
              style={{
                textAlign: "center"
              }}
            ><b>Código de validación enviado</b></h4>
           {/*  <h5>
              {typeSelected === "SMS"
                ? `Ingresa el código verificador que hemos enviado a tu número de teléfono o al correo electrónico. En caso de no recibir el mensaje intenta nuevamente`
                : "El código verificador ha sido enviado a tu correo, en caso de no recibir el mensaje revisa tu carpeta de Spam y Correos no deseados."}
            </h5> */}
          </div>
        </div>

        <p
          className="componentesLogin dataInfo col-xs-12 col-sm-12 col-md-12 col-lg-12"
          style={{
            fontSize: "16px",
            //fontWeight: "bolder",
            //color: "black",
            textAlign: "justify"
          }}
         >
          <div>
            <p>Tu código de validación ha sido enviado a tu correo electrónico y número de teléfono, en caso de no recibir el mensaje revisa tu carpeta de Spam y Correos no deseados.</p>
            <p><b>Número de teléfono:</b> {phoneMasked}</p>
            <p><b>Correo electrónico:</b> {emailMasked}</p>
          </div>
        </p>

        <div
          className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <TextBox
            key="code1"
            id="code1"
            maxLength="7"
            width="100"
            mode="tel"
            tabIndex={1}
            height="31"
            style={
              codeError
                ? { ...codeInputStyle, border: "1px solid red" }
                : codeInputStyle
            }
            onValueChanged={this.handleChange}
            valueChangeEvent="input"
          />
        </div>
        {codeError && <span style={{ color: "red" }}>Código inválido</span>}

        <div
          className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
          style={{ textAlign: "center" }}
        >
          <Button
            style={styles.fullWidth}
            text="Validar código"
            type="default"
            disabled={disabled}
            onClick={nextStep}
          />
          <Button
            style={{ ...styles.fullWidth, marginTop: 20 }}
            text="Reenviar código"
            type="success"
            //onClick={reSend}
            onClick={() => this.props.dispatch(ReenviarCodigoActivacionSMS())}
          />
        </div>
        <div className="registro justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className="contrasena justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <a
                onClick={() => dispatch(renderRedirectFlujoValidacionIdentidad())}
              >
              <span>¿No tienes acceso a este número de Teléfono o Correo Electrónico? </span>
              <span>Prueba aquí con otro método</span>
              </a>
            </div>
          </div>
      </div>
    );
  }
}

export default Step3;
